import { AppBar, Toolbar as MuiToolbar, styled } from "@mui/material"

import MenuIcon from "@mui/icons-material/Menu"
import { useRef } from "react"
import PhcAshcaLarge from "../../assets/svg-components/PhcAshcaLarge"
import { extraColors } from "../../utils/theme"
import DrawerNav from "../DrawerNav"
import { UserNavigation } from "./UserNavigation"

const StyledAppBar = styled(AppBar)(() => ({
  background: extraColors.dark,
  padding: "0px 12px",
  // be above map drawers
  zIndex: 1201,
}))

const Toolbar = styled(MuiToolbar)(() => ({
  display: "grid",
  justifyContent: "space-between",
  textAlign: "center",
  gridAutoFlow: "column",
  "&": { padding: 0 },
}))

const ToolbarContainer = styled("div")(() => ({
  marginLeft: "auto",
}))

export const MobileHeader: React.FC = () => {
  const ref = useRef<{ toggle(): void }>(null)

  return (
    <>
      <StyledAppBar position="static" elevation={0} data-testid="mobile-header">
        <Toolbar color="white">
          <MenuIcon
            height="40"
            width="35"
            onClick={() => ref.current?.toggle()}
            cursor="pointer"
            style={{ color: extraColors.status.navyLight }}
          />
          <PhcAshcaLarge style={{ height: 40, width: "auto" }} />
          <ToolbarContainer>
            <UserNavigation />
          </ToolbarContainer>
        </Toolbar>
        <DrawerNav ref={ref} />
      </StyledAppBar>
    </>
  )
}
